import React from 'react';

import BlogAdsense from './adsense/ad-slot';
import BlogAdBanner from '../right-rail/ad-banner';

let forceAdsense;
const BlogAdContainer = props => {
    let { originCountryCode } = props;

    try {
        forceAdsense = /(\?|&)blogadsense=true/.test(document.location.search);
    } catch (e) { }

    return (
        originCountryCode === 'non-US' || forceAdsense
            ? <BlogAdsense {...props} />
            : <BlogAdBanner {...props} />
    );
}

export default BlogAdContainer;